import { RECORDING_PRIVATE_MESSAGE } from '../../lib/recordingVisibility';

export function LockIcon({ className = 'w-4 h-4' }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 20 20"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path
        fillRule="evenodd"
        d="M10 1a4.5 4.5 0 0 0-4.5 4.5V9H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-.5V5.5A4.5 4.5 0 0 0 10 1Zm3 8V5.5a3 3 0 1 0-6 0V9h6Z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export function RecordingPrivateBadge() {
  return (
    <span
      className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-600"
      title={RECORDING_PRIVATE_MESSAGE}
      data-testid="recording-private-badge"
    >
      <LockIcon className="w-3 h-3" />
      Private
    </span>
  );
}

export function RecordingPrivateNotice() {
  return (
    <p
      className="flex items-center gap-2 text-sm text-gray-500 bg-gray-50 border border-gray-200 rounded-md px-3 py-2"
      role="note"
    >
      <LockIcon className="w-4 h-4 shrink-0 text-gray-400" />
      {RECORDING_PRIVATE_MESSAGE}
    </p>
  );
}
